module.exports = __webpack_public_path__ + "static/media/adjust-alt.4166d092.svg";